var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal fade custom-modal",
      class: _vm.classes,
      attrs: {
        id: _vm.target,
        role: "dialog",
        "aria-labelledby": "modal-label",
        "data-backdrop": "static",
        "data-keyboard": "false",
        "aria-hidden": "true",
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog",
          class: _vm.sizeClass,
          attrs: { role: "document" },
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header d-flex" }, [
              _c(
                "h5",
                {
                  staticClass: "modal-title flex-grow-1",
                  attrs: { id: "modal-label" },
                },
                [_vm._v(_vm._s(_vm.modalTitle))]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "close",
                  attrs: { type: "button", "aria-label": "Close" },
                  on: { click: _vm.close },
                },
                [
                  _c("span", { attrs: { "aria-hidden": "true" } }, [
                    _vm._v("×"),
                  ]),
                ]
              ),
            ]),
            _vm._v(" "),
            _vm.hasBody
              ? _c("div", { staticClass: "modal-body" }, [_vm._t("body")], 2)
              : _vm._e(),
            _vm._v(" "),
            _vm.hasSlot("footer")
              ? _c(
                  "div",
                  { staticClass: "modal-footer" },
                  [
                    _vm._t("footer", function () {
                      return [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-outline-gray",
                            attrs: { type: "button" },
                            on: { click: _vm.close },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.Lang.get("messages.cancel")) +
                                "\n          "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-danger",
                            attrs: {
                              type: "button",
                              disabled: _vm.button_status,
                            },
                            on: { click: _vm.confirm },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.Lang.get("messages.confirm")) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    }),
                  ],
                  2
                )
              : _vm._e(),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }